import React from "react";
import { View, Heading } from "tamagui";

type EventDetailTitleProps = {
  title: string;
};

export const EventDetailTitle = ({ title }: EventDetailTitleProps) => {
  return (
    <View
      bg="$brandYellow"
      py="$4"
      px="$4"
      borderTopWidth={1}
      w="100%"
      borderBottomWidth={1}
    >
      <Heading size="$4" textTransform="uppercase" fontFamily="$heading">
        {title}
      </Heading>
    </View>
  );
};
